import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Package, Users, ClipboardList, ShoppingCart, MessageSquare, Mail, Settings, LogOut, Menu } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/catalogue", label: "Catalogue", icon: Package },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/applications", label: "Partner Applications", icon: ClipboardList },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
  { to: "/admin/email-log", label: "Email Log", icon: Mail },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export function AdminLayout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  const Content = () => (
    <>
      <div className="px-6 py-6 flex items-center gap-2">
        <span className="text-2xl font-extrabold tracking-tight text-white">sambiva</span>
        <span className="text-[10px] font-bold uppercase tracking-widest text-sambiva-yellow bg-white/10 px-1.5 py-0.5 rounded">Admin</span>
      </div>
      <nav className="flex-1 px-3 space-y-0.5 overflow-y-auto no-scrollbar">
        {nav.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setOpen(false)}
            className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-white/15 text-white" : "text-white/70 hover:bg-white/8 hover:text-white"}`}>
            <n.icon size={17} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <div className="px-4 py-1 text-xs text-white/50 truncate">{user?.email}</div>
        <button data-testid="admin-logout" onClick={doLogout} className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-white/70 hover:bg-white/8 hover:text-white w-full"><LogOut size={17} /> Logout</button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-[#f6f7f9] flex">
      <aside className="hidden lg:flex w-60 bg-sambiva-deepgreen flex-col fixed inset-y-0"><Content /></aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-40 flex">
          <div className="w-60 bg-sambiva-deepgreen flex flex-col"><Content /></div>
          <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-60">
        <header className="bg-white border-b border-black/5 px-4 sm:px-8 py-4 flex items-center gap-3 sticky top-0 z-30">
          <button className="lg:hidden" onClick={() => setOpen(true)}><Menu size={24} /></button>
          <h1 className="text-xl font-semibold text-sambiva-charcoal">{title}</h1>
        </header>
        <div className="p-4 sm:p-8">{children}</div>
      </div>
    </div>
  );
}
